import { createFileRoute, redirect } from "@tanstack/react-router";
import { Role } from "@/core/components/auth/auth.types";
import { ErrorComponent } from "@/core/components/ErrorComponent";
import { LoadingList } from "@/core/components/LoadingList";
import { getEventById } from "@/core/components/sites/site/events/eventsQueryOptions";

export const Route = createFileRoute(
	"/_layout/dashboard/sites/$siteId/events/$eventId/",
)({
	beforeLoad: ({ context: { auth } }) => {
		if (auth.isExpired()) {
			return;
		}
		if (!auth.isAuthenticated) {
			throw redirect({
				to: "/",
			});
		}
		if (
			auth.user?.role === Role["Front-Desk"] ||
			auth.user?.role === Role["Blogger"]
		) {
			throw redirect({
				to: "/dashboard",
			});
		}
	},
	loader: ({ context: { queryClient, auth }, params: { siteId, eventId } }) => {
		const event = queryClient.ensureQueryData(
			getEventById(siteId, auth.token!, eventId),
		);
		return {
			event,
		};
	},
	pendingComponent: LoadingList,
	errorComponent: ErrorComponent,
});
